// Docs available at https://github.com/farzher/fuzzysort
import FuzzySort from "fuzzysort-esm";
import { sanitizeHtml } from "./sanitize";
export const searchTermProcessing = (str) => str
    .split(" ")
    .map((part) => part.toLowerCase().trim())
    .filter((part) => part.length !== 0);
export const fuzzySearch = (searchTerm, list, key, opts) => {
    const { limit, threshold } = opts ?? {};
    const result = FuzzySort.go(searchTerm, list, {
        key,
        limit: limit ?? 100,
        threshold: threshold ?? 0.3
    });
    return result.map((r) => r.obj);
};
// Text highlighting utility function
export const highlightMatchingText = (text, searchTerm) => {
    if (!text || !searchTerm || !searchTerm.trim()) {
        return sanitizeHtml(text, "text");
    }
    const escapedSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`(${escapedSearchTerm})`, "gi");
    const highlighted = text.replace(regex, "<strong>$1</strong>");
    return sanitizeHtml(highlighted, "preview");
};
export const normalizeSearchTerm = (searchTerm) => {
    return searchTerm ? searchTerm.toLowerCase().trim() : "";
};
export const matchesSearchTerm = (text, searchTerm) => {
    if (!searchTerm || !searchTerm.trim())
        return true;
    return text.toLowerCase().includes(searchTerm.toLowerCase().trim());
};
